<template>

      <v-app-bar
        color="primary"
      >
        <template v-slot:prepend>
            <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        </template>
        <a href="https://www.sos-water.eu/" target="_blank">
          <v-img
            :src="getLogoUrl()"
            max-width="300px"
            height="50"
            width="50"
            cover
          ></v-img>
        </a>

        <v-app-bar-title
          href="https://www.sos-water.eu/"
          >{{configHeader.header_text}}</v-app-bar-title>

        <template v-slot:append>
          <v-btn icon="mdi-chart-arc" @click.stop="chartDrawer = !chartDrawer" :disabled="!chartData"></v-btn>
        </template>
      </v-app-bar>


        <v-navigation-drawer
            v-model="drawer"
            :location="$vuetify.display.mobile ? 'bottom' : undefined"
            temporary
            class="bg-primary opacity-60 w-full max-w-md flex"
          >

             <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4 opacity-100 ml-9 mr-9">
              <div className="p-8 rounded-lg shadow-xl w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
                  
                </h2>

                <div className="mb-6">
                    <v-select
                        v-model="selectedBasin"
                        :items="basins"
                        item-value="basin_id"
                        item-title="basin_name"
                        return-object
                        label="Basin"
                        variant="outlined"
                        density="compact"
                        class="bg-primary"
                        @update:modelValue="sendDataRequest(select_request)"
                  ></v-select>

                </div>

                <div className="mb-6">
                    <v-select
                        v-model="selectedSubBasin"
                        :items="subasins"
                        label="Sub basin"
                        item-title="sub_basin_name"
                        item-value="sub_basin_id"
                        variant="outlined"
                        density="compact"
                        class="bg-primary"
                        :disabled="subasins.length == 0"
                        @update:modelValue="sendDataRequest(select_request)"
                  ></v-select>
                </div>

                <div className="mb-6">
                    <v-select
                        v-model="selectedIndicatorClass"
                        :items="indicator_classes"
                        item-value="function_name"
                        item-title="function_name"
                        label="Indicator class"
                        variant="outlined"
                        density="compact"
                        class="bg-primary"
                        @update:modelValue="sendDataRequest(select_request)"
                  ></v-select>
                </div>         

                <div className="mb-6">
                    <v-select
                        v-model="selectedIndicator"
                        :items="indicators"
                        label="Indicator"
                        item-value="indicator_id"
                        item-title="indicator_name"
                        variant="outlined"
                        density="compact"
                        class="bg-primary"
                        @update:modelValue="sendDataRequest(select_request)"
                  ></v-select>
                </div>  

                <div className="mb-6">

                    <v-select
                        v-model="selectedScenario"
                        :items="scenarios"
                        label="Scenario"
                        item-value="scenario_id"
                        item-title="scenario_name"
                        variant="outlined"
                        density="compact"
                        class="bg-primary"
                        @update:modelValue="sendDataRequest(select_request)"
                  ></v-select>
                   <div className="mt-1 flex flex-col space-y-2">
                  </div>
                </div>
              </div>
            </div>

          </v-navigation-drawer>

          <v-navigation-drawer
            v-model="chartDrawer"
            class="bg-sky-500/50 opacity-90"
            style="height:80%; top:10%; right:1%"
            location="right"
            floating="true"
            width=500
          >
          <ChartBox
              v-if="props.chartData"
              :chartData="chartDataView"
              :infoData="infoData"
              :display_indicator_info="display_indicator_info"
          >
          </ChartBox>
        </v-navigation-drawer>

</template>



<script setup>

  import { ref, watch, defineProps, defineEmits} from 'vue'
  import ChartBox from './ChartBox.vue';

  import configService from '@/assets/js-scripts/configService';
  const configHeader = configService.getConfigHeader();


  const props = defineProps({
    basins: {
      type: Array,
      required: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
    infoData: {
      type: Object,
      required: true,
    },
    display_indicator_info: {
      type: Object,
      required: false
    }
  });


  const selectedBasin = ref('');
  const selectedSubBasin = ref(null);
  const subasins = ref([])

  const selectedIndicatorClass = ref('')
  const indicator_classes = ref([])

  const selectedIndicator = ref('')
  const indicators = ref([])

  const selectedScenario = ref('')
  const scenarios = ref([])

  const drawer = ref(false)
  const group = ref(null)

  const chartDrawer = ref(false)
  const chartGroup = ref(false)

  const select_request = {
      'basin_id': null,
      'subasin_id': null,
      'indicator_id': null,
      'scenario_id': null,
  }

  const send_request = ref(false); //when true, emit the request data to the app
  const emit = defineEmits(['sendDataRequest']);

  const chartDataView = ref('');


  //fill the sub-basin options and indicators classes
  watch(selectedBasin, () => {

    //sub basins
    selectedSubBasin.value = '' //reset selected option from previous basin 
    subasins.value = selectedBasin.value.sub_basins;

    //indicator classes
    selectedIndicatorClass.value = ''
    let indicators_obj = selectedBasin.value.indicators //get indicators object
    let all_classes = indicators_obj.map(a => a.function_name); //get unique set of classes
    let uniq = [...new Set(all_classes)]; //convert set into array
    indicator_classes.value = uniq;

    //scenarios
    selectedScenario.value = ''
    scenarios.value = selectedBasin.value.scenarios;

  });

  //set sub basin in request
  watch(selectedSubBasin, () => {
    //select_request['subasin'] = selectedSubBasin.value;
  });

  //fill indicators based on selected indicator class
  watch(selectedIndicatorClass, () => {

    //indicators
    selectedIndicator.value = '' //reset selected option from previous indicator class 

    let class_name = selectedIndicatorClass.value; //get current indicator class

    let indicators_array = selectedBasin.value.indicators.filter(function (el) {
        return el.function_name == class_name
      }
    );
    indicators.value = indicators_array;
  });

  //set indicator name in the request
  watch(selectedIndicator, () => {
    //select_request['indicator_name'] = selectedIndicator.value;
  });

  //drawer menu close
  watch(group, () => {
    drawer.value = false
  });

  //chart drawer menu close
  watch(chartGroup, () => {
   chartDrawer.value = false
  });

  //Watch for changes in polarData prop and update chartData
  watch(() => props.chartData, (newVal) => {
    
    chartDataView.value = newVal;

  }, { deep: true });



  const sendDataRequest = (request_data) => {

      //TODO: add check also for indicator class change
      //select_request['indicator_name'] = null;

      if(select_request['basin_id'] != selectedBasin.value.basin_id){

        //cleanup request data and v-models if basin changes
        resetDataRequest();
        select_request['basin_id'] = selectedBasin.value.basin_id;

      }
      else{

        if(subasins.value.length == 0){
          select_request['subasin_id'] = -1; //if the basin has no subasins, set subasin to empty string to pass sendRequestTest
        }
        else{
          select_request['subasin_id'] = selectedSubBasin.value;
        }
        select_request['scenario_id'] = selectedScenario.value;
        select_request['indicator_id'] = selectedIndicator.value;

        if(sendRequestTest() == true){
          //console.log('ready');
          drawer.value = false; //close the drawer to show the map
          emit('sendDataRequest', request_data);
        }
      }
    };


  function sendRequestTest(){
    //Test if all the fields required for requesting data are filled 
    var params_count = 0;

    if(select_request['basin_id'] != null & select_request['basin_id'].toString().length>0  ){
      params_count+=1;
    }
    if(select_request['subasin_id']!=null & select_request['subasin_id'].toString().length>0){
      params_count+=1;
    }
    if(select_request['indicator_id']!=null & select_request['indicator_id'].toString().length>0){
      params_count+=1;
    }
    if(select_request['scenario_id'] != null & select_request['scenario_id'].toString().length>0){
      params_count+=1;
    }

    if(params_count == 4){
      send_request.value = true
    }
    else{
      send_request.value = false
    }

    return send_request.value;

  }

  function resetDataRequest(){
    //reset the data when a new basin is select

    select_request['basin_id'] = null;
    select_request['subasin_id'] = null
    select_request['indicator_id'] =  null
    select_request['scenario_id'] =  null

    selectedSubBasin.value = null
    subasins.value = []
    selectedIndicatorClass.value = ''
    indicator_classes.value = []
    selectedScenario.value = null

  }

  function getLogoUrl(){
    return require(`@/assets/logo-circle-300dpi.png`);
  }


</script>
